﻿$.fn.dxCtrlWizardAnim = function custom_dxCtrlWizardAnim(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlwizardanim dx-ctrl");
        this.createInstance(new cdxCtrlWizardAnim(this, option));
    }
    return this;
}

window.cdxCtrlWizardAnim = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.isInPopup == 'undefined') option.isInPopup = true
    if (typeof option.isInPage == 'undefined') option.isInPage = false
    var isPhone = (parametre.isPhone || option.forcePhone)
    var currentHistoryIndex = 0
    function mConstruit() {
        container.empty();

        if (option.isInPopup) {
            var opt = {
                fullScreen: true,
                showTitle: false,
                shading: true,
                contentTemplate: function (contentElement) {
                    //contentElement.closest(".dx-popup-normal").css("background-color", "transparent")
                    contentElement.css("padding", "0")
                    contentElement.css("position", "relative")
                    if (typeof option.showClose == 'undefined' || option.showClose) {
                        var dxBtClose = $("<div style='position:absolute;z-index:101;top:2px;right:5px'/>").appendTo(contentElement).dxCtrlButton({
                            icon: 'fas fa-times',
                            width: HeightButton,
                            height: HeightButton,
                            onClick: function (e) {
                                popup.hide()
                            }
                        }).dxCtrlButton("instance");
                    }
                    var $Div = $("<div style='position:relative;width:100%;height:100%;'/>").appendTo(contentElement)
                    mRempli($Div)
                }
            }
            popup = container.appendTo("body").dxCtrlPopupBase(opt).dxCtrlPopupBase("instance")
            popup.show()
        } else { mRempli(container) }

    }

    var dxBtPrevious = null
    var dxBtNext = null
    var $DivLstPage = null
    var $DivItem = null
    var $DivItemInner = null
    var ctrlCurrent = null
    var contentTotal = null
    function mRempli(contentElement) {
        contentElement.css("position", "relative")
        contentTotal = contentElement

        var $Table = $("<table style='left:300px;max-width:650px;table-layout:fixed;position:absolute;bottom:5px;z-index:1;margin:0 50px;width:calc(100% - 400px);'/>").appendTo(contentElement)
        if (isPhone) $Table.css("left", "60px")
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%'/>").appendTo($Tr)
        var $Td = $("<td style='width:117px'/>").appendTo($Tr)
        dxBtPrevious = $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Précédent",
            onClick: function (e) {
                mShowItem(option.lstItem[option.lstItem.indexOf(ctrlCurrent) - 1], true)
            }
        }).dxCtrlButton("instance")
        var $Td = $("<td style='width:95px;padding-left:5px;'/>").appendTo($Tr)
        dxBtNext = $("<div/>").appendTo($Td).dxCtrlButton({
            text: "Suivant",
            onClick: function (e) {
                if (ctrlCurrent.isOkForNext()) {
                    mShowItem(option.lstItem[option.lstItem.indexOf(ctrlCurrent) + 1], true)
                } else {
                    //mNotify("Veuillez répondre à l'ensemble des questions pour continuer", "error", 6000)
                }
            }
        }).dxCtrlButton("instance")


        $DivLstPage = $("<div style='position:absolute;top:0;left:0;width:300px;height:100%;z-index:1;' class='containerlstpage'/>").appendTo(contentElement)
        if (isPhone) $DivLstPage.css({ "width": "30px" })
        //if (isPhone) $DivLstPage.css({ "width": "50px", left: "-20px" })
        dxCtrlLst = $("<div style='height:100%;width:100%;'/>").appendTo($DivLstPage).dxCtrlWizardAnimLstItem({
            bddCtrl: option.bddCtrl,
            lstItem: option.lstItem,
            forcePhone: option.forcePhone,
            onSelect: function (idx) {
                mShowItem(option.lstItem[idx])
            },
            indexSelectedPage: option.indexSelectedPage
        }).dxCtrlWizardAnimLstItem("instance")

        option.lstItem.forEach(function (dxAnimItemType) {
            dxAnimItemType.option("onNext", function () { dxBtNext.performClick() })
            dxAnimItemType.option("onPrevious", function () { dxBtPrevious.performClick() })
        })

        if (option.dataSociete) {
            var $ImgLogo = $("<img src='" + parametre.img + "' style='position:absolute;top:25px;right:25px;opacity:0.3;width:120px;'>").appendTo(contentElement)
            option.bddCtrl.getObjet(option.dataSociete).mGetData64Image(function (dataImgUrl) {
                if ((dataImgUrl).length > 0) {
                    $ImgLogo.attr("src", dataImgUrl)
                } else {
                    $ImgLogo.attr("src", parametre.img)
                }
            }, true)
        } else {
            $("<img src='" + parametre.img + "' style='position:absolute;top:25px;right:25px;opacity:0.3;width:120px;'>").appendTo(contentElement)
        }

        $DivItem = $("<div style='position:absolute;top:0;left:300px;width:calc(100% - 300px);height:100%;z-index:0;'/>").appendTo(contentElement)
        if (isPhone) $DivItem.css({ "left": "15px", "width": "calc(100% - 15px)" })
        $DivItemInner = $("<div style='position:relative;width:100%;display:flex;align-items:center;height:100%;'/>").appendTo($DivItem)

        if (option.isInPage) {
            // Écouter l'événement popstate
            $(window).on('popstate', function (event) {
                // Récupérer l'index actuel de l'historique
                var idxPage = parseInt(ctrlCurrent.mGetIndexFromUrlLink(location.pathname))
                mShowItem(option.lstItem[idxPage], false)
            });

            //on intialise l'url de départ
            //si on avait pas de sondage_reponse, on en a créé un
            //du coup on remplace l'url pour que le f5 envoi au bonne endroit

            //puis on check l'url
            var urlLink = option.lstItem[(option.indexSelectedPage ? option.indexSelectedPage : 0)].mGetUrlLink()
            var newPath = new URL(urlLink, location.origin).pathname
            if (location.pathname !== newPath) {
                history.replaceState({ foo: 'bar' }, parametre.nom, urlLink);
            }

            mShowItem(option.lstItem[(option.indexSelectedPage ? option.indexSelectedPage : 0)], false)
        } else {
            mShowItem(option.lstItem[(option.indexSelectedPage ? option.indexSelectedPage : 0)], false)
        }

    }

    var elAnimatingOut = null
    var elAnimatingIn = null

    function mForceFinishAnimation(el) {
        if (!el) return
        var node = el[0]
        if (!node) return
        node.dispatchEvent(new Event('animationend', { bubbles: true, cancelable: true }))
    }

    function mShowItem(ctrlFin, isManuel) {
        if (typeof isManuel == 'undefined') isManuel = true

        if (elAnimatingOut) {
            mForceFinishAnimation(elAnimatingOut)
            elAnimatingOut = null
        }
        if (elAnimatingIn) {
            mForceFinishAnimation(elAnimatingIn)
            elAnimatingIn = null
        }

        var ctrlNext = null
        var animateOut = "rotateOutUpLeft"
        var animateIn = "rotateInUpLeft"
        var animationDuration = 0.8

        if (ctrlCurrent != null) {
            var idxCurrent = option.lstItem.indexOf(ctrlCurrent)
            var idxNew = option.lstItem.indexOf(ctrlFin)
            if (idxNew < idxCurrent) {
                animateOut = "rotateOutDownLeft"
                animateIn = "rotateInDownLeft"
            }
            if (idxNew > idxCurrent) {
                ctrlNext = option.lstItem[option.lstItem.indexOf(ctrlCurrent) + 1]
            }
            else {
                ctrlNext = option.lstItem[option.lstItem.indexOf(ctrlCurrent) - 1]
            }
            var oldCtrlCurrent = ctrlCurrent
            oldCtrlCurrent.hasAnswer = true
            oldCtrlCurrent.element().css("--animate-duration", animationDuration + "s")
            // pivot forcé à gauche-centre (au lieu de gauche-bas par défaut dans animate.css)
            oldCtrlCurrent.element()[0].style.setProperty("transform-origin", "left center", "important")
            oldCtrlCurrent.element().stop()

            elAnimatingOut = oldCtrlCurrent.element()
            animateCSS(oldCtrlCurrent.element(), animateOut).then((message) => {
                // Ne cache l'élément QUE s'il n'est plus l'élément courant au moment
                // où ce callback s'exécute réellement (protège contre un retour rapide dessus)
                if (oldCtrlCurrent !== ctrlCurrent) {
                    oldCtrlCurrent.element().hide()
                }
                if (elAnimatingOut && elAnimatingOut.is(oldCtrlCurrent.element())) elAnimatingOut = null
            });
        } else {
            ctrlNext = ctrlFin
        }

        if (!ctrlNext) {
            debugger;
            return
        }
        if (!ctrlNext.element().is(ctrlFin.element())) {
            ctrlNext = ctrlFin
        }

        ctrlCurrent = ctrlNext
        if (ctrlCurrent.mIsActivated) ctrlCurrent.mIsActivated()
        dxBtPrevious.option("visible", option.lstItem.indexOf(ctrlCurrent) > 0 && ctrlCurrent.btPreviousVisible())
        dxBtNext.option("visible", option.lstItem.indexOf(ctrlCurrent) < option.lstItem.length - 1 && ctrlCurrent.btNextVisible())
        ctrlNext.element().appendTo($DivItemInner)
        ctrlNext.element().css("--animate-duration", animationDuration + "s")
        // pivot forcé à gauche-centre également pour l'animation d'entrée
        ctrlNext.element()[0].style.setProperty("transform-origin", "left center", "important")
        ctrlNext.element().show()
        ctrlNext.mResize()
        dxCtrlLst.mSetCurrent(ctrlNext)
        ctrlNext.element().stop()

        elAnimatingIn = ctrlNext.element()
        animateCSS(ctrlNext.element(), animateIn).then((message) => {
            ctrlNext.mResize()
            if (elAnimatingIn && elAnimatingIn.is(ctrlNext.element())) elAnimatingIn = null
            if (!ctrlNext.element().is(ctrlFin.element())) { mShowItem(ctrlFin, false) }
        });

        var proprieteImg = ctrlCurrent.mGetProprieteImage()
        if (proprieteImg && proprieteImg.url.length > 0) {
            if (proprieteImg.position != "Haut" && proprieteImg.position != "Droite" && proprieteImg.position != "Bas" && proprieteImg.position != "Gauche") {
                //aléatoire
                var valeur = Math.floor(Math.random() * 4) + 1;
                proprieteImg.position = (valeur == 1 ? "Haut" : (valeur == 2 ? "Droite" : (valeur == 3 ? "Bas" : "Gauche")))
            }
            switch (proprieteImg.position) {
                case "Haut":
                    contentTotal.css({
                        "background-repeat": "no-repeat",
                        "background-position": "top center",
                        "background-size": "100% 100%, 100% 100%, cover",
                        "background-image": "linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 100%), linear-gradient(to bottom, rgba(255,255,255,0) 36%, white 60%), url('" + proprieteImg.url + "')"
                    });
                    break;
                case "Droite":
                    contentTotal.css({
                        "box-sizing": "border-box",
                        "padding-left": "40%",
                        "background-origin": "content-box",
                        "background-clip": "content-box",
                        "background-repeat": "no-repeat",
                        "background-position": "center right",
                        "background-size": "100% 100%, cover",
                        "background-image": "linear-gradient(to left, rgba(255,255,255,0) 60%, white 100%), url('" + proprieteImg.url + "')"
                    });
                    //contentTotal.css({
                    //    "background-repeat": "no-repeat",
                    //    "background-position": "center right",
                    //    "background-size": "60% 100%",
                    //    "background-image": "linear-gradient(to left, rgba(255,255,255,0) 60%, white 100%), url('" + proprieteImg.url + "')"
                    //});
                    break;
                case "Bas":
                    contentTotal.css({
                        "background-repeat": "no-repeat",
                        "background-position": "bottom center",
                        "background-size": "100% 100%, 100% 100%, cover",
                        "background-image": "linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 100%), linear-gradient(to top, rgba(255,255,255,0) 36%, white 60%), url('" + proprieteImg.url + "')"
                    });
                    break;
                case "Gauche":
                    contentTotal.css({
                        "box-sizing": "border-box",
                        "padding-right": "40%",
                        "background-origin": "content-box",
                        "background-clip": "content-box",
                        "background-repeat": "no-repeat",
                        "background-position": "center left",
                        "background-size": "100% 100%, cover",
                        "background-image": "linear-gradient(to left, white 0%, rgba(255,255,255,0.7) 100%), url('" + proprieteImg.url + "')"
                    });
                    //contentTotal.css({
                    //    "background-repeat": "no-repeat",
                    //    "background-position": "center left",
                    //    "background-size": "60% 100%",
                    //    "background-image": "linear-gradient(to left, white 0%, rgba(255,255,255,0.7) 100%), url('" + proprieteImg.url + "')"
                    //});
                    break;
            }
        } else {
            contentTotal.css({
                "background-image": ""
            })
        }

        if (option.isInPage && isManuel) {
            var urlLink = ctrlCurrent.mGetUrlLink()
            history.pushState({ foo: 'bar' }, parametre.nom, urlLink);
        }
    }

    this.element = function () { return container; }

    mConstruit();
}